<ng-container *ngIf="action !== 'showContent'">
	<app-form-view [popup]="'true'">
		<form-title>
			{{title}}
		</form-title>
		<content-area>
			<div class="functional-role-form" fxLayout="column" fxLayoutAlign="start stretch">
				<div fxLayout="row" fxLayoutAlign="center start">
					<div fxFlex="80%" fxFlex.xs="100%" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
						<ng-container *ngIf="info">
							<div class="form-info">
								<p class="body-text">
									{{info}}
								</p>
							</div>
						</ng-container>
						<div fxLayout="row" fxLayoutAlign="center center">
							<div fxLayout="column" fxLayoutAlign="start stretch" fxFlex="95" fxFlex.xs="100" fxLayoutGap="20px"
								fxLayoutGap.xs="10px">
								<div fxLayout="row" fxLayoutAlign="center start" class="form-container">
									<app-form-group [fieldList]="formFields" [config]="config" fxLayout="column"
										fxLayoutAlign="start stretch" fxLayout.xs="column" fxLayoutAlign.xs="start stretch"
										fxLayoutGap="0px" fxLayoutGap.xs="0px" (formObject)="formObjectReader($event)">
									</app-form-group>
								</div>
								<div fxLayout="column" fxLayoutAlign="start stretch">
									<app-alert id="functionalRole"></app-alert>
									<div class="button-container" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<button [disabled]="submitDisable" (click)="update()" mat-stroked-button class="main-btn"
											type="button">{{locale.translate('ok')}}</button>
										<button [disabled]="submitDisable" (click)="popupRef.close('cancel')" mat-button class="cancel-btn"
											type="button">{{locale.translate('cancel')}}</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</content-area>
	</app-form-view>
</ng-container>

<ng-container *ngIf="action === 'showContent'">
	<app-content-view>
		<content-title>
			{{title}}
		</content-title>
		<content-area>
			<div class="functional-role" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px">
				<div class="permission-content-block" fxLayout="column" fxLayoutAlign="start stretch">
					<ng-container *ngFor="let content of record?.attributes?.helpText">
						<ul>
						<li>
						<div class="permission-content">{{ content }}</div>
						</li>
						</ul>
					</ng-container>
				</div>
				<div fxLayout="column" fxLayoutAlign="start stretch">
					<div class="button-container" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
						<button [disabled]="submitDisable" (click)="popupRef.close('close')" mat-stroked-button class="cancel-btn"
							type="button">{{locale.translate('close')}}</button>
					</div>
				</div>
			</div>
		</content-area>
	</app-content-view>
</ng-container>
